import {
  DerivedUnderwritingProfileStatus,
  Duration,
  IdDocumentType,
  JobRiskClass,
  ProposalStatus,
  ReplaceInsurance,
  RiderType,
} from '@emma-labs/shared/typescript';

export const englishTranslation = new Map([
  ['Oui', 'Yes'],
  ['Non', 'No'],
  ['Ventes', 'Sales'],
  ['Profil', 'Profile'],
  ['Documentation', 'Documentation'],
  ['Compte bancaire', 'Bank account'],
  ['Carte de crédit', 'Credit card'],
  ['NONE', 'None'],
  [RiderType.CHILD, 'Child'],
  [RiderType.CANCER, 'Cancer'],
  [RiderType.CRITICAL_ILLNESS, 'Critical illness'],
  [RiderType.DISABILITY, 'Disability'],
  [RiderType.ACCIDENTAL_DEATH, 'Accidental death'],
  [RiderType.GUARANTEED_INSURABILITY, 'Guaranteed insurability'],
  [RiderType.WAIVER_OF_PREMIUM, 'Waiver of premium'],
  ['CHILD_ENDORSEMENT_15K', '$15,000 coverage'],
  ['CHILD_ENDORSEMENT_25K', '$25,000 coverage'],
  ['driverLicense', "Driver's license"],
  ['healthInsurance', 'Health insurance identification'],
  ['passport', 'Passport'],
  ['PROPOSAL_IN_PROGRESS_BTN', 'Continue proposal'],
  ['PROPOSAL_SENT_BTN', 'Modify proposal'],
  ['SALE_COMPLETED_BTN', 'View proposal'],
  ['SEND_PROPOSAL', 'Send proposal to client'],
  ['RESEND_PROPOSAL', 'Send client a reminder'],
  ['Soumission rapide', 'Quick Quote'],
  ['Recherche client', 'Client Search'],
  ['Rapports de vente', 'Sale Reports'],
  ['Espace tarification', 'Underwriting space'],
  ['Emma Élite', 'Emma Elite'],
  ['Emma Supérieur', 'Emma Superior'],
  ['Emma Standard', 'Emma Standard'],
  ['Comparateur de soumission', 'Quote Comparator'],
  [
    'Impossible de copier le client, vous devez le faire manuellement',
    'Cannot copy the client, you need to do it manually',
  ],
  [
    'Le client a été copié dans la plateforme de courtage avec succès',
    'The client has been successfully copied into the brokerage platform',
  ],
  [
    'Une erreur est survenue durant la copie du client vers la plateforme de courtage',
    'An error has occurred while copying the client to the brokerage platform',
  ],
  [`Voir plus d'options`, `See more options`],
  [`Voir moins d'options`, `See less options`],
  [DerivedUnderwritingProfileStatus.APPROVED, 'Approved'],
  [DerivedUnderwritingProfileStatus.REFUSED, 'Refused'],
  [DerivedUnderwritingProfileStatus.PENDING_UNDERWRITER_ACTION, 'Pending underwriter'],
  [DerivedUnderwritingProfileStatus.PENDING_CLIENT_ACTION, 'Pending client'],
  [DerivedUnderwritingProfileStatus.PENDING_EXTERNAL_ACTION, 'Pending external partner'],
  [DerivedUnderwritingProfileStatus.CANCELED, 'No follow-up'],
  [IdDocumentType.DRIVER_LICENSE, `Driver's License`],
  [IdDocumentType.HEALTH_INSURANCE, 'Health Insurance Card'],
  [IdDocumentType.PASSPORT, 'Passport'],
  [ProposalStatus.ONGOING, 'Ongoing'],
  [ProposalStatus.PENDING_CHECKOUT, 'Signature'],
  [ProposalStatus.PENDING_UNDERWRITING, 'Underwriting'],
  [ProposalStatus.PENDING_EXTRA_QUESTIONNAIRES, 'Additional Questionnaires'],
  [ProposalStatus.PENDING_EXTERNAL_ACTION, 'Pending external partner'],
  [ProposalStatus.PENDING_MODIFICATION_DECISION, 'Decision'],
  [ProposalStatus.APPROVED, 'Approved'],
  [ProposalStatus.REFUSED, 'Refused'],
  [ProposalStatus.ABANDONED, 'Abandoned'],
  [ReplaceInsurance.YES, 'Replace'],
  [ReplaceInsurance.NO, 'Keep'],
  [ReplaceInsurance.UNKNOWN, `I don't know`],
  [JobRiskClass.INELIGIBLE, 'Ineligible'],
  [Duration.P100, 'Payable to age 100'],
  [Duration.P65, 'Payable to age 65'],
  [Duration.V20, 'Payable in 20 years'],
]);
